import {noop} from 'lodash'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {ReactNode} from 'react'

export type AutoCompleteLastOperation =
  | 'initialization'
  | 'productLoading'
  | 'availabilitiesLoading'
  | 'calendarLoading'
  | 'guestsSelection'
  | 'dateSelection'
  | 'optionIdSelection'
  | 'availabilityIdSelection'

type AutoCompleteHelperContextValue = {
  lastOperation: AutoCompleteLastOperation
  changeLastOperation: (operation: AutoCompleteLastOperation) => void
}

type Props = {
  children: ReactNode
}

const AutoCompleteHelperContext = React.createContext<AutoCompleteHelperContextValue>({
  lastOperation: 'initialization',
  changeLastOperation: noop,
})

export const AutoCompleteHelper = ({children}: Props) => {
  const [lastOperation, setLastOperation] = useState<AutoCompleteLastOperation>('initialization')

  const changeLastOperation = useCallback((operation: AutoCompleteLastOperation) => {
    setLastOperation(operation)
  }, [])

  const value = useMemo(() => {
    return {
      lastOperation,
      changeLastOperation,
    }
  }, [lastOperation, changeLastOperation])

  return <AutoCompleteHelperContext.Provider value={value}>{children}</AutoCompleteHelperContext.Provider>
}

AutoCompleteHelper.useLastOperation = () => {
  return useContext(AutoCompleteHelperContext).lastOperation
}

AutoCompleteHelper.useChangeLastOperation = () => {
  return useContext(AutoCompleteHelperContext).changeLastOperation
}
